// extracted by mini-css-extract-plugin
export default {"wrap":"b-z","heading":"c-z","formError":"d-z"};